import { pitch } from "./Pitch.css";
import { PitchProps } from "./types";

const Pitch = ({ sponsor = "default", children }: PitchProps) => (
  <div className={pitch} data-sponsor={sponsor}>
    {children}
  </div>
);

export default Pitch;
